import { render } from "./KeywordAutocomplete.vue?vue&type=template&id=b55ad056"
import script from "./KeywordAutocomplete.vue?vue&type=script&lang=js"
export * from "./KeywordAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__